
<template>

    <div class="dropup d-inline-block">
        <button class="btn btn-success dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
            Solve shortfalls
        </button>
        <ul class="dropdown-menu">
            <li>
                <button class="dropdown-item"
                        @click="$emit('solve-take-less')"
                        :disabled="disableButtons">
                    Take less
                </button>
            </li>
            <li>
                <button class="dropdown-item"
                        @click="$emit('solve-pay-more')"
                        :disabled="disableButtons || !hasPensionPots">
                    Pay more
                </button>
            </li>
            <li>
                <button v-if="equityReleaseEnabled"
                        class="dropdown-item"
                        @click="$emit('solve-equity-release')"
                        :disabled="disableButtons">
                    Home equity
                </button>
            </li>
        </ul>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "SolveButtons",
  emits: ["solve-take-less", "solve-pay-more", "solve-equity-release"],
  data() {
    return {
      disableButtons: false
    };
  },
  computed: {
    hasPensionPots: function(): boolean {
      return this.$store.state.retiree?.pensionPots.pots.length > 0;
    },
    equityReleaseEnabled(): boolean {
      return this.$store.state.configuration.solveIncludesEquityRelease;
    }
  },
  methods: {
    setDisabledState(disabled: boolean) {
      this.disableButtons = disabled;
    }
  }
});
</script>
